import React, { useEffect, useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import axios from 'axios';

export const base_url = process.env.REACT_APP_API_URL;

const ProfitLoss = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [userData, setUserData] = useState([]);
  const [totals, setTotals] = useState({
    totalWalletMoney: 0,
    totalProfit: 0,
    totalLoss: 0,
    netAll: 0,
  });

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchUserData = async (filters = {}) => {
    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.post(base_url + '/api/webapi/profitLoss', filters, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`,
        },
      });

      const aggregatedData = response?.data?.data || [];

      setUserData(aggregatedData);

      // Calculate totals
      const calculatedTotals = aggregatedData.reduce((acc, user) => {
        return {
          totalWalletMoney: acc.totalWalletMoney + parseFloat(user.money || 0),
          totalProfit: acc.totalProfit + parseFloat(user.total_profit || 0),
          totalLoss: acc.totalLoss + parseFloat(user.total_loss || 0),
          netAll: acc.netAll + parseFloat(user.total_profit || 0) + parseFloat(user.total_loss || 0),
        };
      }, { totalWalletMoney: 0, totalProfit: 0, totalLoss: 0, netAll: 0 });

      setTotals(calculatedTotals);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchUserData(); // On page load: full history
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleFilter = () => {
    if (!startDate || !endDate) return alert("Select both dates");
    fetchUserData({ startDate, endDate });
  };

  const handleReset = () => {
    setStartDate('');
    setEndDate('');
    fetchUserData();
  };


  return (
    <div className="wrapper">
      <AdminSidebar 
        isSidebarOpen={isSidebarOpen} 
        toggleSidebar={toggleSidebar} 
        isMobile={isMobile}
      />
      <AdminHeader 
        toggleSidebar={toggleSidebar} 
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />
      <div className={`content-wrapper ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"}`} style={{ marginLeft: (!isMobile && isSidebarOpen) ? "" : "0", transition: "margin-left 0.3s ease" }}>
        <div className="container-fluid">
          <h1 className="page-title custom_pagetitle">
            <i className="sidebar-mini-lock"></i> Profit / Loss
          </h1>


          <div className="page-content browse">
            
            <div className="row">
              <div className="col-md-12 oneonofftab">
                <div className="panel panel-bordered p-3">
                  {/* Filter Controls */}
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="form-control" />
                    </div>
                    <div className="col-md-3">
                      <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="form-control" />
                    </div>
                    <div className="col-md-3">
                      <button className="btn btn-primary" onClick={handleFilter}>Filter</button>
                      <button className="btn btn-secondary ml-2" onClick={handleReset}>Reset</button>
                    </div>
                  </div>
                  <div className="panel-body">
                    <table className="table table-responsive-lg table-hover">
                      <thead>
                        <tr>
                          <th className="text-center">Name</th>
                          <th className="text-center">Role</th>
                          <th className="text-center">Wallet Money</th>
                          <th className="text-center">Total Profit</th>
                          <th className="text-center">Total Loss</th>
                          <th className="text-center">P/L</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData.length > 0 ? (
                          userData.map((user, index) => (
                            <tr key={index}>
                              <td className="text-center">{user.username}</td>
                              <td className="text-center">{user.role}</td>
                              <td className="text-center">{parseFloat(user.balance).toFixed(2)}</td>
                              <td className="text-center">{parseFloat(user.total_profit).toFixed(2)}</td>
                              <td className="text-center">{parseFloat(user.total_loss).toFixed(2)}</td>
                              <td className={`text-center ${(parseFloat(user.total_profit)-parseFloat(user.total_loss))>0 ? 'text-green' : 'text-red'}`}>{parseFloat(user.total_profit)-parseFloat(user.total_loss)}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">No data available</td>
                          </tr>
                        )}
                        {/* Totals row */}
                        {userData.length > 0 && (
                          <>
                            <tr className="table-info font-weight-bold">
                              <td className="text-center" colSpan="2"><strong>TOTAL</strong></td>
                              <td className="text-center"><strong>{totals.totalWalletMoney.toFixed(2)}</strong></td>
                              <td className="text-center"><strong>{totals.totalProfit.toFixed(2)}</strong></td>
                              <td className="text-center"><strong>{totals.totalLoss.toFixed(2)}</strong></td>
                              <td className={`text-center font-weight-bold`}>
                                <strong>{totals.netAll.toFixed(2)}</strong>
                              </td>

                            </tr>
                            
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default ProfitLoss;
